/**
 * The CRUX section registry, mirroring cli/paradigm_cli/commands/crux.py SECTIONS.
 *
 * `paradigm crux push` stores the document as {format, sections, dlr}, where
 * `sections` is keyed by these pattern strings. The portal reads and writes the
 * same keys so a CRUX written in the repo and one edited here are the same
 * document — anything unrecognised is carried through untouched rather than
 * dropped.
 *
 * Generated from the CLI list and held to it by cruxSections.test.js. They had
 * already drifted: this file was missing 5.9 Ecosystem surfaces and keyed
 * Encryption to 5.9, which the CLI uses for Ecosystem surfaces — so the same
 * text would have been stored under different keys depending on which tool
 * wrote it.
 */
export const CRUX_SECTIONS = [
  { pattern: '^## 1\\. The app', label: 'The app', required: true, score: null },
  { pattern: '^## 2\\. Why Paradigm', label: 'Why Paradigm', required: true, score: 'value' },
  { pattern: '^## 3\\. Reuse', label: 'Reuse', required: true, score: 'value' },
  { pattern: '^## 4\\. Derivation', label: 'Derivation', required: true, score: 'value' },
  { pattern: '^## 5\\. Everyday decisions', label: 'Everyday decisions', required: true, score: 'value' },
  { pattern: '^## 6\\. Identity', label: 'Identity, and at scale', required: true, score: 'value' },
  { pattern: '^## 7\\. Workflows', label: 'Workflows', required: true, score: 'readiness' },
  { pattern: '^## 8\\. Views', label: 'Views', required: true, score: 'readiness' },
  { pattern: '^## 9\\. First run', label: 'First run', required: true, score: 'readiness' },
  { pattern: '^## 10\\. What it deliberately', label: 'What it deliberately doesn\'t do', required: true, score: 'readiness' },
  { pattern: '^## 11\\. Schemas', label: 'Schemas used, and why', required: true, score: 'usage' },
  { pattern: '^## 12\\. Custom schemas', label: 'Custom schemas', required: false, score: 'usage' },
  { pattern: '^## 13\\. Cross-app connections', label: 'Cross-app connections', required: true, score: 'usage' },
  { pattern: '^## 14\\. Stratum', label: 'Stratum & ratification', required: true, score: 'usage' },
  { pattern: '^## 15\\. Platform features', label: 'Platform features', required: true, score: 'usage' },
  { pattern: '^## 16\\. Its own data', label: 'Its own data', required: true, score: 'usage' },
];

/**
 * The rail groups by which score a section is evidence for, not by chapter.
 *
 * Chapters were an outline of the document. These are the three questions the
 * document exists to answer, so a person writing section 4 can see that it is
 * the claim they are making and not paperwork.
 */
export const SECTION_GROUPS = [
  { score: null, title: 'The app', of: null },
  { score: 'value', title: 'The claim', of: 'Societal value add' },
  { score: 'readiness', title: 'The work', of: 'Readiness' },
  { score: 'usage', title: 'The footing', of: 'Paradigm feature usage' },
];

/** Which group a section belongs to. */
export function groupOf(pattern) {
  const s = CRUX_SECTIONS.find(x => x.pattern === pattern);
  return SECTION_GROUPS.find(g => g.score === (s ? s.score : null)) || SECTION_GROUPS[0];
}

/** Progress over the sections that are required. */
export function cruxProgress(sections) {
  const required = CRUX_SECTIONS.filter(s => s.required);
  const filled = required.filter(s => String(sections?.[s.pattern] || '').trim());
  return {
    requiredTotal: required.length,
    requiredDone: filled.length,
    percent: required.length ? Math.round((filled.length / required.length) * 100) : 0,
    complete: filled.length === required.length,
    nextUnfinished: required.find(s => !String(sections?.[s.pattern] || '').trim()) || null,
  };
}
